import React from 'react';
import {Pagination, Segment, Header, Grid} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {compileContent} from 'common/utils';
import _ from 'lodash';

const NUM_RESULTS_PER_PAGE = 10;

export class ResultsList extends React.Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    numResultsPerPage: NUM_RESULTS_PER_PAGE,
  };

  handlePageChange = (e, {activePage}) => {
    this.props.handlePageChange(activePage);
  };

  renderPageWrapper = ({children}) => {
    const {header, page, totalRecords, numResultsPerPage, data} = this.props;
    let totalNumPages = _.ceil(totalRecords / numResultsPerPage);
    let showPrevButton = page > 1 ? undefined : null;
    let showNextButton = page < totalNumPages ? undefined : null;
    let indexBase = (page - 1) * numResultsPerPage;
    let startingRecordIndex = indexBase + 1;
    let endingRecordIndex = indexBase + data.length;
    return (
      <Segment vertical>
        {header && <Header as="h2">{header}</Header>}
        <Segment>
          {children}
          <Segment vertical padded="very">
            <Grid verticalAlign="middle">
              <Grid.Column width={2}>
                {startingRecordIndex} to {endingRecordIndex} of {totalRecords}{' '}
              </Grid.Column>
              <Grid.Column width={12}>
                {!!totalNumPages && (
                  <Pagination
                    size="small"
                    prevItem={showPrevButton}
                    nextItem={showNextButton}
                    firstItem={showPrevButton}
                    lastItem={showNextButton}
                    activePage={page}
                    totalPages={totalNumPages}
                    onPageChange={this.handlePageChange}
                  />
                )}
              </Grid.Column>
            </Grid>
          </Segment>
        </Segment>
      </Segment>
    );
  };

  compile(template, rowData) {
    return compileContent(template, {rowData});
  }

  renderCell = (config, index, data) => {
    const {linkTo, text} = config;
    let c = (template) => this.compile(template, data);
    let compiledLink = c(linkTo);
    let compiledText = c(text);

    return (
      <FemaGoTable.TextCell key={index}>
        {!_.isEmpty(linkTo) ? (
          <Link title={compiledText} to={compiledLink || ''}>
            {compiledText}
          </Link>
        ) : (
          compiledText
        )}
      </FemaGoTable.TextCell>
    );
  };

  render() {
    const {config, data} = this.props;
    const ResultsListWrapper = this.renderPageWrapper;

    return (
      <ResultsListWrapper>
        <FemaGoTable type="static">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              {_.map(config, (columnConfig, index) => (
                <FemaGoTable.HeaderCell key={index}>
                  {columnConfig.header}
                </FemaGoTable.HeaderCell>
              ))}
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          {!_.isEmpty(data) ? (
            <FemaGoTable.Body>
              {_.map(data, (rowData, index) => (
                <FemaGoTable.Row key={index}>
                  {_.map(config, (columnConfig, index) =>
                    this.renderCell(columnConfig, index, rowData)
                  )}
                </FemaGoTable.Row>
              ))}
            </FemaGoTable.Body>
          ) : (
            ''
          )}
        </FemaGoTable>
      </ResultsListWrapper>
    );
  }
}

export default ResultsList;
